import React from 'react'
import { useConnect } from 'sb-redux-hook'

import { ContentLoader } from 'components/_new/ui'


export type ContentLoaderAwareOfRequestLoaderProps = {
  className?: string
}


const ContentLoaderAwareOfRequestLoader: React.FunctionComponent<ContentLoaderAwareOfRequestLoaderProps> = ({ className }) => {
  const { isHidden } = useConnect({
    isHidden: 'models.ui.isRequestLoaderVisible',
  })

  return !isHidden && (
    <ContentLoader className={className} />
  )
}


export default ContentLoaderAwareOfRequestLoader
